import { render } from "./KSFromFile.vue?vue&type=template&id=78fef651"
import script from "./KSFromFile.vue?vue&type=script&lang=js"
export * from "./KSFromFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__